<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row">
      <div class="col-sm-12">
        <div class="mb-3">
          <label class="form-label text-capitalize-first">{{ helper.trans('labels.rate_change_mode') }}</label>
          <select v-model="formData.mode" class="form-select" required>
            <option value="">{{ helper.trans('labels.select_mode') }}</option>
            <option value="RATE_UP_ON">{{ helper.trans('rate_change_modes.rate_up_on') }}</option>
            <option value="RATE_DOWN_ON">{{ helper.trans('rate_change_modes.rate_down_on') }}</option>
            <option value="RATE_UP_UNTIL">{{ helper.trans('rate_change_modes.rate_up_until') }}</option>
            <option value="RATE_DOWN_UNTIL">{{ helper.trans('rate_change_modes.rate_down_until') }}</option>
            <option value="RATE_SET_ALL">{{ helper.trans('rate_change_modes.rate_set_all') }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label text-capitalize-first">{{ helper.trans('labels.rate_value') }} (%)</label>
          <input type="number" step="0.01" min="0" max="100" v-model="formData.value" class="form-control" required>
        </div>
        <div class="mb-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="formData.updateAll" id="updateAllCheckbox">
            <label class="form-check-label text-capitalize-first" for="updateAllCheckbox">
              {{ helper.trans('labels.update_all_traders') }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </LoaderWrapper>
</template>

<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {api} from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import TrafficGroupRateChangeRequestDTO from "@/models/request/TrafficGroupRateChangeRequestDTO";
import {RateChangeMode} from "@/models/enum/RateChangeMode";

interface FormData {
  mode: RateChangeMode | ''
  value: string
  updateAll: boolean
}

const notification = useNotification()

export default defineComponent({
  components: {
    LoaderWrapper,
  },
  props: {
    trafficGroupId: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const formData = ref({
      mode: '',
      value: '',
      updateAll: false
    } as FormData);

    const save = async (): Promise<void> => {
      if (formData.value.mode === '' || !formData.value.value) {
        notification.notify({
          type: 'error',
          title: helper.trans('error'),
          text: helper.trans('error.fill_required_fields')
        })
        return;
      }

      const requestData: TrafficGroupRateChangeRequestDTO = {
        mode: formData.value.mode as RateChangeMode,
        value: formData.value.value,
        updateAll: formData.value.updateAll
      };

      loader.value?.show()
      try {
        await api.call.trafficGroups.changeRates(props.trafficGroupId, requestData)
        notification.notify({
          type: 'success',
          title: helper.trans('success'),
          text: helper.trans('success.rates_changed')
        })
      } catch (error) {
        notification.notify({
          type: 'error',
          title: helper.trans('error'),
          text: helper.trans('error.unable_to_change_rates')
        })
        throw error;
      } finally {
        loader.value?.hide()
      }
    }

    const reset = () => {
      formData.value.mode = ''
      formData.value.value = ''
      formData.value.updateAll = false
    }

    return {
      formData,
      loader,
      helper,
      save,
      reset
    }
  }
})
</script> 